const bp = {
  mobile: '490px',
  tablet: '768px',
  desktop: '1024px',
};

export { bp };
